<template>
    <div class="text-content px-4 px-lg-0 px-lx-0">
        <div v-if="subHeaderTitleText" class="w-100 sub-header-title-text" :class="subHeaderTitleTextClass">
            {{ subHeaderTitleText }}
        </div>
        <div class="w-100 title-text py-3" :class="titleTextClass">
            {{ titleText }}
        </div>
        <div class="w-100 sub-title-text" :class="subTitleTextClass" v-html="subTitleText">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            titleText: String,
            subTitleText: String,
            subHeaderTitleText: String,
        },
        computed: {
            isMobile(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            },
            titleTextClass(){
                return this.isMobile ? 'title-text-sm-xs' : 'title-text-md-lg-xl';
            },
            subTitleTextClass(){
                return this.isMobile ? 'sub-title-text-sm-xs' : 'sub-title-text-md-lg-xl';
            },
            subHeaderTitleTextClass() {
                return this.isMobile ? 'sub-header-title-text-sm-xs' : 'sub-header-title-text-md-lg-xl';
            },
        },
    }
</script>

<style scoped>
    .text-content {
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .title-text {
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: center;
    }
    .title-text-md-lg-xl {
        font-size: clamp(24px, 5vw, 60px);
        line-height: clamp(24px, 5vw, 65px);
        color: #ffffff;
    }
    .title-text-sm-xs {
        font-size: clamp(18px, 3vw, 24px);
        line-height: clamp(22px, 3vw, 24px);
        color: #7CDBFF;
    }

    .sub-title-text {
        color: #E6E6E6;
        font-family: Rajdhani;
        font-style: normal;
        line-height: normal;
        text-align: center;
    }
    .sub-header-title-text {
        color: #ffffff;
        text-align: center;
        font-family: GeomGraphic;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .sub-title-text-md-lg-xl, .sub-header-title-text-md-lg-xl {
        font-size: 18px;
        font-weight: 600;
    }
    .sub-title-text-sm-xs, .sub-header-title-text-sm-xs {
        font-size: 14px;
        font-weight: 400;
    }
</style>